import { Component, Input, OnInit } from '@angular/core'
import { Router } from '@angular/router'

import { BsModalRef } from 'ngx-bootstrap/modal'
import { AppRoutesNS } from 'src/app/app-routes.namespace'

@Component({
  selector: 'duplicated-courses-modal-modal',
  templateUrl: './duplicated-courses-modal.component.html',
  styleUrls: ['./duplicated-courses-modal.component.scss']
})
export class DuplicatedCoursesModalComponent implements OnInit {
  @Input() duplicatedCourses: any = []

  constructor(private router: Router, private bsModalRef: BsModalRef) {}
  ngOnInit() {}
  onView(course) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/courses/${course.id}`])
    )
    window.open(url, '_blank')
  }
  onCreateBooking(course) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([
        AppRoutesNS.Course.CREATE_BOOKINGS_FOR_COURSE.replace(
          ':id',
          String(course.id)
        )
      ])
    )
    window.open(url, '_blank')
  }
  onClose() {
    this.bsModalRef.hide()
  }
}
